<template>
    <ModalBase :show-modal="showModal" @close-modal="close" :overlay-scrollb="true">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal">
                <template v-slot:title>
                    <span v-translate>Company product list</span>
                </template>
            </TitleBar>
        </template>
        <template v-slot:maincontent>
            <ProductList />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import ProductList from "@/views/settings/ProductList";

export default {
    name: "ProductListModal",
    components: {ModalBase, TitleBar, ProductList},
    props: {
        showModalOn: {
            type: Array
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.showModal = this.showModalOn.includes(to.name);
                (this.showModal) ? document.body.classList.add('modal-on') : document.body.classList.remove('modal-on');
            }
        }
    },
    data() {
        return {
            showModal: false
        }
    },
    created() {
        window.addEventListener('keydown', this.closeEventListener);
    },
    destroyed () {
        window.removeEventListener('keydown', this.closeEventListener);
    },
    methods: {
        close() {
            this.$router.push({name: 'Products'});
        },
        closeEventListener(event) {
            if (this.showModal && event.key === 'Escape') this.close();
        }
    }
}
</script>

<style scoped>

</style>